export const isLoggedIn = () => {
  const token = localStorage.getItem('token')
  if (token && token.length) {
    return token
  } else {
    return null
  }
}
